import { createSelector } from '@reduxjs/toolkit';

import { coerceBoolean, isOfType } from '@hsp/utilities';

import { transformAggregate } from 'pages/audience/utilities';
import { IAudienceAggregate } from 'types/api/audience';
import { defaultAggregate, defaultAggregateMultiRfm } from 'types/api/audience/defaults';
import { ApplicationState } from 'types/store';

const selectState = (state: ApplicationState) => state.audience.aggregate;

export const selectAudienceAggregate = createSelector(selectState, ({ data }) => {
  return data ?? defaultAggregate;
});

export const selectAudienceAggregateApplied = createSelector(selectState, ({ applied }) =>
  coerceBoolean(applied, true)
);

export const selectAudienceAggregateError = createSelector(selectState, ({ error }) => error);

export const selectAudienceAggregateLoading = createSelector(selectState, ({ loading }) => loading);

export const selectAudienceAggregateTotalDonors = createSelector(selectState, ({ data }) => {
  if (isOfType<IAudienceAggregate>(data, 'totalCount')) {
    const result = data ?? defaultAggregate;

    return result.totalCount;
  }

  const result = data ?? defaultAggregateMultiRfm;

  return result.aggregate.totalCount;
});

export const selectAudienceAggregateTransformed = createSelector(selectAudienceAggregate, (data) => {
  if (isOfType<IAudienceAggregate>(data, 'totalCount')) {
    return transformAggregate(data);
  }

  return transformAggregate(data.aggregate);
});
